// extracted by mini-css-extract-plugin
module.exports = {"mdx":"MDX-module--mdx--1ypyC","h6":"MDX-module--h6--12tZr"};